import { useState, useEffect, FC } from "react";

import Counter from "../../../components/forms/Counter";
import AgeInput from "../components/AgeInput";

const PersonCounter: FC<{ onChange: any; value: any }> = (props) => {
  const [formFields, setFormFields] = useState<any>(props.value);

  useEffect(() => {
    props.onChange(formFields, "people");
  }, [formFields]);

  const addFields = () => {
    setFormFields([...formFields, { age: 18 }]);
  };

  const removeFields = (index: number) => {
    let data = [...formFields];
    data.splice(index, 1);
    setFormFields(data);
  };

  const handleFormChange = (event: any, index: any) => {
    let data: any = [...formFields];
    if (event.target.value < 0) {
      data[index] = { age: 1 };
    } else if (event.target.value > 140) {
      data[index] = { age: parseInt(event.target.value.slice(0, -1)) };
    } else {
      data[index] =
        event.target.value.length > 0
          ? { age: parseInt(event.target.value) }
          : { age: event.target.value };
    }
    setFormFields(data);
  };

  return (
    <div className="person__counter">
      <Counter
        label="Number of people"
        name="peopleNum"
        baseValue={formFields.length ? formFields.length : 1}
        min={1}
        max={20}
        stepper={1}
        onAddClick={addFields}
        onRemoveClick={() => removeFields(formFields.length - 1)}
        disabled={true}
      />
      <div className="person__counter__age">
        {formFields.map((form: any, count: number) => {
          return (
            <AgeInput
              label={`Person ${count + 1} age`}
              inputLabel={`Age`}
              name={`age`}
              value={form.age}
              onChange={(event: any) => handleFormChange(event, count)}
              key={count}
            />
          );
        })}
      </div>
    </div>
  );
};

export default PersonCounter;
